'use client';
import dynamic from 'next/dynamic';

const COMPONENTS_MAP = {
  ParticlesSphere: dynamic(
    () => import('@/app/components/3d/ParticlesSphere/ParticlesSphere'),
    { ssr: false }
  ),
  LiquidSphere: dynamic(
    () => import('@/app/components/3d/LiquidSphere/LiquidSphere'),
    { ssr: false }
  ),
};

const HeroModel = ({
  sphereType = 'ParticlesSphere',
  sphereColor,
  onReady,
}) => {
  const Model = COMPONENTS_MAP[sphereType];

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Model sphereColor={sphereColor} onReady={onReady} />
    </div>
  );
};

export default HeroModel;
